module.exports = __webpack_public_path__ + "img/Home.974f18df.svg";